"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PREDEFINED_TYPES = ['add', 'delete', 'edit', 'download'];

var Button = function (_React$Component) {
  (0, _inherits2.default)(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0, _classCallCheck2.default)(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isClicked: false
    };

    _this.handleClick = function (e) {
      _this.setState({
        isClicked: true
      });

      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }

      _this.timeout = setTimeout(function () {
        return _this.setState({
          isClicked: false
        });
      }, 500);

      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Button, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          type = _this$props.type,
          icon = _this$props.icon,
          to = _this$props.to,
          disabled = _this$props.disabled,
          className = _this$props.className,
          loading = _this$props.loading,
          htmlType = _this$props.htmlType,
          children = _this$props.children,
          secondary = _this$props.secondary,
          othersProps = (0, _objectWithoutProperties2.default)(_this$props, ["type", "icon", "to", "disabled", "className", "loading", "htmlType", "children", "secondary"]);
      var hasPredefinedType = PREDEFINED_TYPES.indexOf(type) !== -1;
      var iconNode = null;

      if (icon && !loading && !hasPredefinedType) {
        var iconProps = {
          type: icon
        };

        if (icon.includes(':')) {
          var _icon$split = icon.split(':'),
              _icon$split2 = (0, _slicedToArray2.default)(_icon$split, 2),
              iconType = _icon$split2[0],
              variant = _icon$split2[1];

          iconProps = {
            type: iconType,
            variant: variant
          };
        }

        iconNode = React.createElement(_Icon.default, Object.assign({}, iconProps, {
          className: "Button__icon"
        }));
      }

      if (loading) {
        iconNode = React.createElement(_Spinner.default, {
          className: "Button__icon"
        });
      }

      var _secondary = secondary;

      if (_secondary && ['primary', 'default'].includes(type)) {
        _secondary = false;
        (0, _warning.default)(type !== 'primary', "Les boutons de type `primary` ne peuvent pas \xEAtre en m\xEAme temps `secondary`.\n" + "Si vous souhaitez passer une bouton primaire en secondaire, utilisez un bouton type `default`.");
        (0, _warning.default)(type !== 'default', "Les boutons de type `default` ne peuvent pas \xEAtre en m\xEAme temps `secondary`.\n" + "En effet, les boutons de type `default` sont d\xE9j\xE0 la version secondaire des boutons type `primary`.");
      }

      (0, _warning.default)(!(htmlType && to), "La prop. `htmlType` (qui ne s'applique qu'aux `<button>`) ne doit pas \xEAtre " + "pass\xE9e en m\xEAme temps que la prop. `to` (qui produit un `<a>`).");

      var _className = (0, _classnames2.default)(className, 'Button', (_classnames = {}, (0, _defineProperty2.default)(_classnames, "Button--".concat(type), type), (0, _defineProperty2.default)(_classnames, 'Button--clicked', this.state.isClicked), (0, _defineProperty2.default)(_classnames, 'Button--loading', loading), (0, _defineProperty2.default)(_classnames, 'Button--disabled', disabled), (0, _defineProperty2.default)(_classnames, 'Button--secondary', _secondary), (0, _defineProperty2.default)(_classnames, 'Button--with-icon', iconNode || hasPredefinedType), _classnames));

      var Element;
      var elementProps = {};

      if (!to) {
        Element = 'button';
        elementProps.type = htmlType || 'button';
      } else {
        Element = 'a';
        elementProps.href = to;
      }

      return React.createElement(Element, Object.assign({}, othersProps, elementProps, {
        className: _className,
        onClick: this.handleClick
      }), iconNode, children && React.createElement("span", {
        className: "Button__content"
      }, children));
    }
  }]);
  return Button;
}(React.Component);

Button.defaultProps = {
  type: 'default',
  icon: undefined,
  loading: false,
  disabled: false,
  secondary: false,
  to: undefined,
  className: '',
  htmlType: undefined,
  onClick: undefined,
  children: undefined
};
var _default = Button;
exports.default = _default;